export default __webpack_public_path__ + "static/media/neha.75f69ccf.jpeg";